<section>
    <div>
        <h1>A página não existe</h1>
        <p>Ops! Não foi possível encontrar a página.</p>
        <button mat-button class="filled" (click)="goToHome()">Ir para a Home</button>
    </div>
</section>